import React from 'react'
import '../style.css'

const Cards = (props) => {
    return (
        <div className="col-lg-4 col-md-4 col-12">
          <div className="card-1">
                             <div className="card mt-4">
  <img src={props.imgsrc} className="card-img-top" alt="..."/>
  <div className="card-body">
    <p className="card-text text-center">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
  </div>
</div>
</div>
        </div>
    )
}

export default Cards
